import React from "react";

// Helpers
import { format } from "date-fns";

// Colors

function EntryInfoModal(props) {
  const { entryPrompt, entryPromptDetails, entryData } = props;

  // Data row with predefined style
  const DataField = (props) => {
    const { fieldName, fieldValue } = props;
    return (
      <div className="flex flex-row w-full py-2">
        <div
          className="flex flex-col lg:flex-row items-center justify-between w-full p-2
                     border border-1 border-neutral-300 rounded-lg"
        >
          <div className="flex flex-1 flex-row items-center justify-start w-full Xbg-red-500">
            <p className="text-lg font-bold text-neutral-800 text-start">
              {fieldName}
            </p>
          </div>
          <div className="py-1 md:py-0" />
          <div className="flex flex-[2] flex-row items-center justify-start lg:justify-end w-full Xbg-blue-500">
            <p className="text-lg font-medium text-neutral-800 lg:text-end">
              {fieldValue}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className="flex flex-col items-center justify-center w-full lg:w-10/12 p-2
                 rounded-2xl Xbg-red-500"
    >
      <div className="flex flex-col items-center justify-center w-full Xbg-green-500">
        <p className="text-5xl font-medium text-neutral-900 text-center">
          {entryPrompt}
        </p>
        <p className="text-lg font-medium text-neutral-900 text-center">
          {entryPromptDetails}
        </p>
      </div>

      <div className="py-2" />

      <div className="flex flex-col items-center justify-center w-full Xbg-purple-500">
        <DataField
          fieldName={"Entry ID"}
          fieldValue={entryData.id ? entryData.id : "Data Unavailable"}
        />
        <DataField
          fieldName={"Patient ID"}
          fieldValue={
            entryData.patient_owner
              ? entryData.patient_owner
              : "Data Unavailable"
          }
        />
        <DataField
          fieldName={"Physician ID"}
          fieldValue={
            entryData.physician_owner
              ? entryData.physician_owner
              : "Data Unavailable"
          }
        />
        <DataField
          fieldName={"Entry Type"}
          fieldValue={
            entryData.entry_type ? entryData.entry_type : "Data Unavailable"
          }
        />
        <DataField
          fieldName={"Date Created"}
          fieldValue={
            entryData.created
              ? format(
                  new Date(entryData.created),
                  "EEEE, MMMM dd, yyyy, h:mm:ss a"
                )
              : "Data Unavailable"
          }
        />
        <DataField
          fieldName={"Date Modified"}
          fieldValue={
            entryData.created
              ? format(
                  new Date(entryData.date_modified),
                  "EEEE, MMMM dd, yyyy, h:mm:ss a"
                )
              : "Data Unavailable"
          }
        />

        <DataField
          fieldName={"Appointment Date"}
          fieldValue={
            entryData.appointment_date
              ? format(
                  new Date(entryData.appointment_date),
                  "EEEE, MMMM dd, yyyy, h:mm:ss a"
                )
              : "Data Unavailable"
          }
        />
      </div>
    </div>
  );
}

export default EntryInfoModal;
